import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { ReportTable, HeadCell } from 'components/Table';
import { useReportColumns } from 'hooks';
import { roundNumber } from "../../shared/functions";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Link from '@mui/material/Link';

const headers: HeadCell[] = [
  {
    id: 'receiptNumber',
    label: '№',
    align: 'right',
    cell: (value, row) => <Link underline='none' target='_blank' href={row.receiptUrl}>{value}</Link>,
  },
  {
    id: 'amount',
    label: 'Сума Чеку ',
    align: 'right'
  },
  {
    id: 'paymentType',
    label: 'Тип оплати',
    align: 'right',
  },
  {
    id: 'productsCount',
    label: 'Кількість товарів',
    align: 'right',
  },
  {
    id: 'dateTimeUtc',
    label: 'Дата і час',
    cell: (value) => dayjs.utc(value).local().format('DD/MM/YYYY HH:mm'),
  },
];

const ReceiptReport: React.FC = () => {
  const rows = useSelector(state => state.reports.returnReport);
  const columns = useReportColumns(headers, rows);

  const { avgAmount, avgProductsCount } = useMemo(() => ({
    avgAmount: rows.length && roundNumber(rows.reduce((sum, { amount = 0 }) => sum + amount, 0) / rows.length),
    avgProductsCount: rows.length && roundNumber(rows.reduce((sum, { productsCount = 0 }) => sum + productsCount, 0) / rows.length),
  }), [rows]);

  return (
    <ReportTable
      idName='order'
      rows={rows}
      columns={columns}
      footer={() => (
        <TableRow>
          <TableCell colSpan={columns.length - 3} />
          <TableCell align='right' >Середнє: {avgAmount}</TableCell>
          <TableCell />
          <TableCell align='right'>Середнє: {avgProductsCount}</TableCell>
        </TableRow>
      )}
    />
  )
};

export default ReceiptReport;
